import React from 'react';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <h1 className='h1-notfound'>404 - Página não encontrada.</h1>
      <p className='p-notfound'>A página que você está procurando não existe.</p>
    </div>
  );
}

export default NotFound;